<!--
 * @Author: guoyu
 * @Date: 2021-04-21 11:59:29
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-10 14:26:26
 * @Description: 陪玩师主页专属红包
-->
<template>
  <div class="over-lay" v-show="dialogVisible">
    <div class="newer-coupon">
      <div class="coupon-top">{{$t('components_login_components_player_redbag_1794')}}<span class="nick-name">{{ nickName }}</span
        >{{$t('components_login_components_player_redbag_1795')}}</div>
      <div class="coupon-amount">
        <span class="amount">120</span>
        <span class="unit">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
      </div>
      <div class="footer-button">
        <NormalButton class="use-coupon" @click="useCoupon"
          >{{$t('components_dialogredbag_first_order_reward_1782')}}</NormalButton
        >
      </div>
      <p class="coupon-text">
        「<span class="nick-name">{{ nickName }}</span
        >{{$t('components_login_components_player_redbag_1796')}}</p>
      <p class="coupon-text">{{$t('components_login_components_player_redbag_1797')}}</p>
      <div class="close-dialog el-icon-circle-close" @click="closeDialog"></div>
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/common/button/normal';
export default {
  name: 'PlayerRedbag',
  components: {
    NormalButton
  },
  props: {
    nickName: {
      type: String,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: true
    };
  },
  methods: {
    useCoupon() {
      this.closeDialog();
      this.$nextTick(() => {
        console.log(this.uuid);
        this.$util
          .Login({ phoneLoginDialog: true, inviterUuid: this.uuid })
          .then(async () => {
            await this.$store.dispatch('app/getUserAccount');
            this.$router.push({
              path: '/coupons'
            });
          });
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.over-lay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
}
.newer-coupon {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 517px;
  height: 534px;
  color: #fec09b;
  background: url(./images/newer-coupon-bg.png) no-repeat;
  background-size: 100% 100%;
}
.coupon-top {
  width: 281px;
  margin: 99px auto 0;
  text-align: center;
  font-size: 24px;
  line-height: 34px;
  color: #feeab7;
}
.coupon-amount {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 200px;
  margin: 48px auto 0;
  font-weight: 600;
  font-weight: 700;
  font-size: 120px;
  line-height: 1;
  color: #fa004fcc;
  text-shadow: 1px 3px 6px #fff, 0 0 0 #000, 1px 3px 6px #fff;
}
.unit {
  margin-top: 12px;
  font-size: 36px;
}
.footer-button {
  margin-top: 36px;
  text-align: center;
}
.use-coupon {
  width: 158px;
  height: 40px;
  margin: 24px auto 24px;
  /deep/ .button-box {
    color: #9b5a12;
  }
}
.coupon-text {
  margin-bottom: 6px;
  font-size: 12px;
  text-align: center;
  line-height: 1;
}
.close-dialog {
  position: absolute;
  bottom: -33px;
  transform: translateY(100%);
  width: 100%;
  text-align: center;
  font-size: 29px;
  color: #ffffff;
}
.nick-name {
  display: inline-block;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
